export enum LenderType {
  INDIVIDUAL = "INDIVIDUAL",
  ENTREPRENEUR = "ENTREPRENEUR",
  LEGAL_ENTITY = "LEGAL_ENTITY",
}
